import React from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Attendance from "../components/Attendance";

const AttendanceDetailsPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id?: string }>();
  const location = useLocation();

  // The calendar passes `state: { event }` when navigating to attendance.
  // Extract the specific session date from the event's start date.
  const eventState = (location.state as any)?.event;
  const sessionDate: string | undefined = eventState?.start
    ? (() => {
        const d = new Date(eventState.start);
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${y}-${m}-${day}`;
      })()
    : undefined;

  return (
    <Attendance
      classId={id}
      sessionDate={sessionDate}
      onBack={() => navigate("/calendar")}
    />
  );
};

export default AttendanceDetailsPage;
